import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";

// img
import user from "../../../../../Assets/images/user.png";
import { Formik } from "formik";
import { addSubAdminSchema, editSubAdminSchema } from "../../../../../helpers/yup_validator";
import visiblePass from "../../../../../Assets/svg/login/visible-pass.svg";
import nonVisiblePass from "../../../../../Assets/svg/login/non-visible-pass.svg";
import { post, get, put } from "../../../../../helpers/api_helper";
import { cloneDeep } from "lodash";
import toast from "react-hot-toast";

const NewSubAdmin = ({ show, onHide, clientDetails, refetch }) => {

  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    password: "",
    profileImage: "",
    phone: "",
    status: "active",
    role: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const validationComponent = (message) => {
    return message && <div style={{ color: "#eb5757" }}>
      {message}
    </div>
  };

  const fetchRoles = useCallback(async () => {
    try {

      setLoading(true);
      const response = await get("/roles/get-all-roles");
      if (response?.success) {
        setLoading(false);
        setRoleOptions(response.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching roles", error);
    }
  }, []);

  const handleFileUpload = async (e, setFieldValue) => {
    try {
      setFileUploading(true);
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      const response = await post("/user/admin/get-file-url", formData);
      if (response?.success) {
        setFieldValue("profileImage", response?.data);
        setFileUploading(false);
      }
    } catch (error) {
      console.log("An error occurred while fetching sub admin", error);
    }
  };

  const handleSubmit = async (values) => {
    try {

      const payload = cloneDeep(values);

      const response = clientDetails ? await put(`/sub-admin/update/${clientDetails?._id}`, payload) : await post("/sub-admin/create", payload);
      if (response?.success) {
        typeof refetch == "function" && refetch();
        onHide();
        toast.success(`Record ${clientDetails ? "updated" : "created"} successfully`);
      }
    } catch (error) {
      console.log("An error occurred while creating sub admin", error);
    }
  };

  useEffect(() => {
    fetchRoles()
  }, []);

  useEffect(() => {
    if (clientDetails) {
      setInitialValues({
        name: clientDetails?.name,
        email: clientDetails?.email,
        profileImage: clientDetails?.profileImage,
        phone: clientDetails?.phone,
        status: clientDetails?.status,
        role: clientDetails?.roleDetails?._id,
      })
    }
  }, [clientDetails])

  return (
    <Modal
      show={show}
      onHide={() => onHide(false)}
      backdrop="static"
      keyboard={false}
      centered
      scrollable="true"
      className="addUpdateContent"
      size="xl"
    >

      <Modal.Header closeButton>
        <Modal.Title>Add User</Modal.Title>
      </Modal.Header>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Modal.Body>
          <Row className="justify-content-center">
            <Col lg="10" className="my-2">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={clientDetails ? editSubAdminSchema : addSubAdminSchema}
                onSubmit={handleSubmit}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  values,
                  errors
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg="12" className="my-2 text-center">
                        <div
                          className={`uploadFile border-0 d-inline-block position-relative mx-auto`}
                        >
                          <input
                            type="file"
                            className="file position-absolute w-100 h-100"
                            onChange={(e) => handleFileUpload(e, setFieldValue)}
                          />
                          {fileUploading ?
                            <div
                              className="d-flex justify-content-center align-items-center rounded-circle"
                              style={{ height: 94, width: 94 }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </Spinner>
                            </div> : < img
                              src={values?.profileImage || user}
                              alt=""
                              className="img-fluid rounded-circle"
                              style={{ height: 94, width: 94 }}
                            />
                          }
                          <span
                            className={`icn position-absolute`}
                            style={{ bottom: 0, right: 0 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 40 40"
                              fill="none"
                            >
                              <circle cx="20" cy="20" r="20" fill="white" />
                              <path
                                d="M27.9898 26.9537C28.5469 26.9537 29 27.4128 29 27.9771C29 28.5425 28.5469 29.0005 27.9898 29.0005H22.2797C21.7226 29.0005 21.2695 28.5425 21.2695 27.9771C21.2695 27.4128 21.7226 26.9537 22.2797 26.9537H27.9898ZM24.0299 11.6996L25.5049 12.8713C26.1098 13.3443 26.513 13.9677 26.6509 14.6235C26.8101 15.3448 26.6403 16.0532 26.1628 16.6659L17.3764 28.0284C16.9732 28.5444 16.3789 28.8346 15.7422 28.8454L12.2404 28.8884C12.0494 28.8884 11.8902 28.7594 11.8478 28.5766L11.0519 25.126C10.914 24.4917 11.0519 23.836 11.4552 23.3308L17.6842 15.2685C17.7903 15.1395 17.9813 15.119 18.1086 15.2147L20.7297 17.3002C20.8995 17.4399 21.1329 17.5152 21.377 17.4829C21.897 17.4184 22.2471 16.9454 22.1941 16.4402C22.1622 16.1822 22.0349 15.9672 21.8651 15.8059C21.8121 15.7629 19.3183 13.7635 19.3183 13.7635C19.1592 13.6345 19.1273 13.398 19.2547 13.2378L20.2416 11.9575C21.1541 10.7858 22.7459 10.6783 24.0299 11.6996Z"
                                fill="url(#paint0_linear_0_15418)"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_0_15418"
                                  x1="20"
                                  y1="11.0005"
                                  x2="20"
                                  y2="29.0005"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#3A674A" />
                                  <stop offset="1" stopColor="#0C3D1D" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </span>
                        </div>
                        {validationComponent(errors.profileImage)}
                      </Col>
                      <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 text-dark">
                          Name
                        </label>
                        <input type="text" className="form-control"
                          name="name"
                          value={values?.name}
                          onChange={handleChange}
                          maxLength={50}
                        />
                        {validationComponent(errors.name)}
                      </Col>
                      <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 text-dark"
                        >
                          Mobile Number
                        </label>
                        <input type="text" className="form-control"
                          name="phone"
                          value={values?.phone}
                          onChange={(e) => {
                            const { value } = e.target;
                            if (/^\d*$/.test(value)) { // Allow only numbers, including an empty string
                              handleChange(e);
                            }
                          }}
                          maxLength={15}
                        />
                        {validationComponent(errors.phone)}
                      </Col>
                      <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 text-dark">
                          Email
                        </label>
                        <input type="text" className="form-control"
                          name="email"
                          value={values?.email}
                          onChange={handleChange}
                        />
                        {validationComponent(errors.email)}
                      </Col>
                      {!clientDetails && <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 text-dark"
                        >
                          Password
                        </label>
                        <div
                          style={{ border: "solid 1px #dee2e6", borderRadius: "0.375rem", height: "37px", overflow: "hidden" }}
                          className="w-100 border-1 d-flex  position-relative align-items-center">

                          <input type={showPassword ? "text" : "password"}
                            className="form-control"
                            style={{ border: "none", outline: "none" }}
                            name="password"
                            value={values?.password}
                            onChange={handleChange}
                          />
                          <Button
                            variant="transparent"
                            className="border-0 p-0 icn position-absolute"
                            style={{ right: "8px" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <img src={visiblePass} alt="" />
                            ) : (
                              <img src={nonVisiblePass} alt="" />
                            )}
                          </Button>
                        </div>
                        {validationComponent(errors.password)}

                      </Col>}
                      <Col lg="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 text-dark">
                          Role
                        </label>
                        <Form.Select
                          className="form-control"
                          aria-label="Default select example"
                          name="role"
                          value={values?.role}
                          onChange={(e) => setFieldValue("role", e.target.value)}
                        >
                          <option value="" disabled>Select</option>
                          {
                            roleOptions?.map((item, index) => {
                              return <option key={index} value={item?._id}>{item?.name}</option>
                            })
                          }
                        </Form.Select>
                        {validationComponent(errors.role)}
                      </Col>
                      <Col lg="12" className="my-2">
                        <div className="d-flex align-items-center justify-content-between gap-10">
                          <div className="left d-flex align-items-center gap-10">
                            <label htmlFor="" className="form-label m-0">
                              Status
                            </label>
                            <Form.Check type="switch" id="custom-switch" label=""
                              name="status"
                              checked={values?.status == "active"}
                              onChange={(e) => setFieldValue("status", e.target.checked ? "active" : "inactive")}
                            />
                          </div>
                          <Button
                            className="d-inline-flex align-items-center justify-content-center commonBtn bordredBtn"
                            type="submit"
                          >
                            Save
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Modal.Body>
      )}

    </Modal>
  );
};

export default NewSubAdmin;
